// Request context stays in this tab's memory. A stale tab must never submit to a newly selected firm.
let activeFirmId = null;
export const getRequestFirmId = () => activeFirmId;
export const setRequestFirmId = (firmId) => { activeFirmId = Number(firmId) || null; };
